export default "__VITE_ASSET__D$kpm4hV__"